import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { venueSchema } from '../../../schemas'

export default function New({
  account,
  accounts,
  navigation
}) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Venue"
    >
      <BackLink href="/manage/venues">Back to Venues</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={venueSchema}
          resource="venue"
          endpoint="/manage/venues"
          backLink="/manage/venues"
          submitLabel="Create Venue"
          defaultValues={{
            name: '',
            description: '',
            capacity: '',
            min_booking_notice_hours: 24,
            setup_time_minutes: 0,
            base_hire_fee_pence: '',
            active: true,
            image: null
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
                placeholder="e.g., Main Lounge, Function Suite"
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={3}
                errors={errors}
                placeholder="Describe this venue space"
              />

              <FormFieldController
                control={control}
                name="capacity"
                label="Capacity"
                type="number"
                errors={errors}
                placeholder="Maximum number of guests"
              />

              <div className="grid grid-cols-2 gap-4">
                <FormFieldController
                  control={control}
                  name="min_booking_notice_hours"
                  label="Min. Notice (hours)"
                  type="number"
                  errors={errors}
                />

                <FormFieldController
                  control={control}
                  name="setup_time_minutes"
                  label="Setup Time (minutes)"
                  type="number"
                  errors={errors}
                />
              </div>

              <FormFieldController
                control={control}
                name="base_hire_fee_pence"
                label="Base Hire Fee (pence)"
                type="number"
                errors={errors}
                placeholder="e.g., 50000 for £500"
                hint="Optional. Leave blank if venue hire is included in packages."
              />

              <FormFieldController
                control={control}
                name="image"
                label="Image"
                type="file"
                accept="image/*"
                hint="Optional. JPG, PNG or WebP recommended."
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="active"
                label="Active"
                type="checkbox"
                defaultValue={true}
                hint="Uncheck to hide this venue from guests"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
